<template>
  <main id="plpContainer" :class="mainComputedClasses" class="search-results w-full max-w-full px-2">
    <div class="container mb-6">
      <trek-marquee :marquee="marqueeData" :is-simplified="true"></trek-marquee>
      <div
        v-if="hasTitlePlp"
        class="w-full md:w-2/3 justify-self-center mt-4"
        data-ga-dimension="dimension8"
        :data-ga-dimension-value="categoryData.titlePlp"
      >
        <header class="text-center">
          <h1 class="title-plp header--lg mb-2">{{ categoryData.titlePlp }}</h1>
          <p class="category-body-copy text-lg">{{ categoryData.bodyPlp }}</p>
        </header>
      </div>
    </div>

    <!-- Slot for main page data -->
    <slot
      name="search-results"
      v-bind="{toggleFiltersState, viewBreakpointLessThan, viewBreakpointMoreThan, areFiltersVisible}"
    ></slot>

    <!-- Default cms slots -->
    <slot v-bind="{toggleFiltersState, viewBreakpointLessThan, viewBreakpointMoreThan, areFiltersVisible}"></slot>
  </main>
</template>

<script>
import {mapActions, mapMutations, mapState, mapGetters} from 'vuex';
import TrekMarquee from '@/components/TrekMarquee';
import {PdlTabs, PdlTabPane} from '@pedal/pdl-tabs';
import {PdlButton} from '@pedal/pdl-button';
import {PdlIcon} from '@pedal/pdl-icon';
import {PdlDrawer} from '@pedal/pdl-drawer';

export default {
  name: 'PlpContainer',
  components: {
    TrekMarquee,
    // eslint-disable-next-line vue/no-unused-components
    PdlButton,
    // eslint-disable-next-line vue/no-unused-components
    PdlIcon,
    // eslint-disable-next-line vue/no-unused-components
    PdlTabs,
    // eslint-disable-next-line vue/no-unused-components
    PdlTabPane,
    // eslint-disable-next-line vue/no-unused-components
    PdlDrawer,
  },
  props: {
    categoryData: {
      type: Object,
      default: null,
    },
    marqueeData: {
      type: Object,
      default: null,
    },
  },

  computed: {
    ...mapGetters('viewSize', ['viewBreakpointLessThan', 'viewBreakpointMoreThan']),
    ...mapState('plp', ['areFiltersVisible']),
    ...mapState('backend', ['isConsumerFriendlyMode']),
    mainComputedClasses() {
      return this.categoryData?.titlePlp || this.marqueeData?.body ? 'mt-4' : 'mt-6';
    },
    hasTitlePlp() {
      return Boolean(this.categoryData?.titlePlp);
    },
  },

  mounted() {
    this.updateLastPlp();
  },

  methods: {
    ...mapMutations('plp', ['setAreFiltersVisible']),
    ...mapActions('storage', ['updateLastPlp']),
    toggleFiltersState() {
      this.setAreFiltersVisible(!this.areFiltersVisible);
    },
  },
};
</script>
